import React, { Component } from 'react'
import Switch from "react-switch";
import axios from 'axios';
import Select from 'react-select';
import { ACCOUNT_CREATED } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';
import { Notifications } from '../common/notification';
import AccountBilling from './accountBilling';



export class AddAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            switched: true,
            limitSwitch:true,
            accountName: '',
            rateUpdateEmail: '',
            accountEmail: '',
            ban: '',
            location: '',
            maxRate: '',
            session: '',
            cps: '',
            credit: '',
            selectType: '',
            profitMarkup: '35%',
            rateEmail:'',
            billingEmail:'',
            closeModal: this.props.close,
            msg: '',
            suspend: false,
            typeOptions: [
                { value: 'postpaid', label: 'Postpaid' },
                { value: 'prepaid', label: 'Prepaid' }
            ],

            selectAccountLCRType: { value: 'system', label: 'True-LCR' },
            optionAccountLCRType: [
                { value: 'system', label: 'True-LCR' },
                { value: 'system-callhold', label: 'LCR Considering Carrier Holdtime' }
            ],

            selectAccountStatus: { value: 'Enabled', label: 'Enabled' },
            optionAccountStatus: [
                { value: 'Credit Hold', label: 'Credit Hold' },
                { value: 'Enabled', label: 'Enabled' },
                { value: 'Disabled', label: 'Disabled' }
            ],
            isLoad:false,
            cName:'callerID',
            inboundCustomerId:0,
            stirLevel:{ value: '1', label: 'No Treatment' },
            optionStir: [
                { value: '1', label: 'No Treatment' },
                { value: '2', label: 'Block Unsigned' },
                { value: '3', label: 'Sign Unsigned Calls with Attestation A' },
                { value: '4', label: 'Sign Unsigned Calls with Attestation B' },
                { value: '5', label: 'Sign Unsigned Calls with Attestation C' },
            ],
            invoiceLevel:{ value: 'Weekly', label: 'Weekly' },
            optionInvoice: [
                { value: 'Semi-monthly', label: 'Semi-monthly' },
                { value: 'Monthly', label: 'Monthly' },
            ],
        }
        this.handleChange = this.handleChange.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.onSubmitChange = this.onSubmitChange.bind(this)
        this.handleSelectType = this.handleSelectType.bind(this)
        this.toggleSwitchSuspend = this.toggleSwitchSuspend.bind(this)
        this.toggleLimitSwitch = this.toggleLimitSwitch.bind(this)
        this.handleSelectStatus = this.handleSelectStatus.bind(this)
        this.handleSelectAccountLCRType = this.handleSelectAccountLCRType.bind(this)
        this.handleSelectStir = this.handleSelectStir.bind(this)
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    toggleLimitSwitch() {
        this.setState({ limitSwitch: !this.state.limitSwitch })
    }

    toggleSwitchSuspend() {
        this.setState({ suspend: !this.state.suspend })
    }

    handleSelectStir(stirLevel) {
        this.setState({ stirLevel})
    }

    handleSelectInvoice(invoiceLevel) {
        this.setState({ invoiceLevel})
    }


    handleSelectAccountLCRType(selectAccountLCRType) {
        this.setState({ selectAccountLCRType });
        console.log(`Option selectedAccountLCRType:`, selectAccountLCRType);
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSelectType(selectType) {
        this.setState({ selectType });
        console.log(`selectType:`, selectType);
    };

    handleSelectStatus(selectAccountStatus) {
        this.setState({ selectAccountStatus });
        console.log(`selectAccountStatus:`, selectAccountStatus);
    };

    clearForm() {
        this.setState({
            switched: false,
            accountName: '',
            accountEmail: '',
            rateUpdateEmail: '',
            billingEmail: '',
            ban: '',
            location: '',
            session: '',
            cps: '',
            credit: '',
            maxRate: '',
            minimumProfit: '',
            cName:'callerID',
            profitMarkup: '35%'
        })
    }

    onSubmitChange() {
        const { accountName, stirLevel,accountEmail, rateUpdateEmail, billingEmail, ban, location, session, minimumProfit, invoiceLevel, cps, switched, credit, suspend, limitSwitch,  selectAccountStatus, cName, profitMarkup, selectAccountLCRType, maxRate } = this.state
        const accountAdd = {
            "accountName": accountName,
            "accountEmail": accountEmail,
            "rateUpdateEmail": rateUpdateEmail,
            "billingEmail": billingEmail,
            "ban": ban,
            "location": location,
            "sessions": parseInt(session),
            "cps": parseInt(cps),
            "creditLimit": parseInt(credit),
            "accountType": "*postpaid",
            "accountLCRType": selectAccountLCRType.value,
            "maxRate": maxRate,
            "minimumProfit": minimumProfit,
            "suspend": suspend,
            "active": switched,
            'disableACTAfterLIM':limitSwitch,
            'status':selectAccountStatus.value,
            // 'cname':cName,
            "stirShakenLevel":stirLevel.value,
            "invoice":invoiceLevel.value,
            'profitMarkup':profitMarkup,
        };
        this.setState({isLoad:true})
        console.log(`accountAdd`, accountAdd)
        if (accountName == '' || accountEmail == '') {
            console.log('fill form');
            Notifications.notify("One of form field is empty", "Failed", "error")
            this.setState({isLoad:false})

        }
        else if (session == '' || cps == '') {
            console.log('fill session');
            Notifications.notify("One of form field is empty", "Failed", "error")
            this.setState({isLoad:false})


        }
        else {
            var headers = { 'Authorization': "Bearer " + this.state.User.token }
            axios.post(ACCOUNT_CREATED, accountAdd, { headers }).then(res => {
                if (res) {
                    console.log("responseeee", res)
                    this.setState({
                        msg: res.data.message,
                        isLoad:false
                    })
                    this.props.close()
                    this.props.classListing()
                    Notifications.notify(this.state.msg, "Created", "success")
                }
                else {
                    Notifications.notify("failed Account Created", "Failed", "error")
                    this.setState({isLoad:false})
                }
            }).catch(err => {
                var msessage = err.response.data.message
                console.log(`msessage`, msessage)
                Notifications.notify(msessage, "Failed", "error")
                this.props.close()
                this.setState({isLoad:false})
            })
            console.log('accounAdd :>> ', accountAdd);
        }

    }

    render() {
        const { accountName, accountEmail, minimumProfit, ban, location, session, cps, credit, profitMarkup, rateUpdateEmail, billingEmail, inboundCustomerId, systemLCROptions, typeOptions, suspend,cName, maxRate } = this.state

        return (
            <div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}} >Account Name</label>
                            <input type="text" className="form-control" name="accountName" value={accountName} onChange={this.handleChange} placeholder="Enter account name" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}} >Account Email</label>
                            <input type="email" className="form-control" name="accountEmail" value={accountEmail} onChange={this.handleChange} placeholder="Enter account email" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Rate Update Email</label>
                            <input type="email" className="form-control" name="rateUpdateEmail" value={rateUpdateEmail} onChange={this.handleChange} placeholder="i.e. rates@xyzcompany.com" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Billing Email (For Invoice)</label>
                            <input type="email" className="form-control" name="billingEmail" value={billingEmail} onChange={this.handleChange} placeholder="Billing Email" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Billing Account Number (BAN)</label>
                            <input type="text" className="form-control" name="ban" value={ban} onChange={this.handleChange} placeholder="Enter BAN" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Address</label>
                            <input type="text" className="form-control" name="location" value={location} onChange={this.handleChange} placeholder="Enter account address" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Session</label>
                            <input type="number" className="form-control" name="session" value={session} onChange={this.handleChange} placeholder="Enter session" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>CPS</label>
                            <input type="number" className="form-control" name="cps" value={cps} onChange={this.handleChange} placeholder="Enter cps" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Credit Limit</label>
                            <input type="number" className="form-control" name="credit" value={credit} onChange={this.handleChange} placeholder="Enter credit limit" required />
                        </div>
                    </div>

                    <div className="col-md-4">
                        {/* <div className="form-group">
                            <label >C-Name</label>
                            <input type="text" className="form-control" name="cName" value={cName} onChange={this.handleChange} placeholder="Enter cName" required />
                        </div> */}
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Stir Shaken Level </label>
                            <Select
                                value={this.state.stirLevel}
                                onChange={this.handleSelectStir}
                                options={this.state.optionStir}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Invoice Period </label>
                            <Select
                                value={this.state.invoiceLevel}
                                onChange={this.handleSelectInvoice}
                                options={this.state.optionInvoice}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Account Status</label>
                            <Select
                                value={this.state.selectAccountStatus}
                                onChange={this.handleSelectStatus}
                                options={this.state.optionAccountStatus}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Account LCR Type</label>
                        <Select
                            value={this.state.selectAccountLCRType}
                            onChange={this.handleSelectAccountLCRType}
                            options={this.state.optionAccountLCRType}
                        />
                    </div>

                    <div className="col-md-4 ">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Minimum Profit</label>
                            <input type="text" className="form-control"  name="minimumProfit" value={minimumProfit} onChange={this.handleChange} placeholder="Enter Minimum Profit" required />
                        </div>
                    </div>


                    <div className="col-md-4 ">
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Max Rate</label>
                            <input type="text" className="form-control"  name="maxRate" value={maxRate} onChange={this.handleChange} placeholder="Enter Max Rate" required />
                        </div>
                    </div>

                    <div className="col-md-4 ">
                                    <div className="form-group">
                                        <label style={{fontWeight:'400',fontSize:'16px'}}>Profit Markup</label>
                                        <input type="text" className="form-control"  name="profitMarkup" value={profitMarkup} onChange={this.handleChange} placeholder="Enter Profit Markup" required />
                                    </div>
                            </div>

                    <div className="col-md-4">
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}} class="custom-control  custom-checkbox mt-2">
                            <input type="checkbox" class="custom-control-input" onChange={this.toggleLimitSwitch} checked={this.state.limitSwitch} />
                            <span class="custom-control-label">Enforce Credit Limit</span>
                        </label>
                            <small id="emailHelp" class="form-text text-muted fs-14">This Enforces Credit limit(no calls upon Credit limit) on the account</small>
                        </div>
                    </div>
                </div>
                <div style={{borderTop:'1px solid #e9ecef'}} className="row">
                <div className="col-md-6 ml-auto">
                    <button type="submit" className="main-button mt-2 btn btn-primary bt-sm float-right" onClick={this.onSubmitChange} disabled={this.state.isLoad ? true :false} > Create <i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " : 'icon-file-plus ml-1 '}></i> </button>
                </div>
            </div>
            </div>
        )
    }
}

export default AddAccount
